import React, { Component } from 'react';
import { getColor } from '../../../../../../models/market-map/data-parser';
import './index.css';


class Popup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mouseX:0
    }
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  componentDidMount(){
    window.addEventListener('mousemove', this.handleMouseMove)
  }
  
  componentWillUnmount(){
    window.removeEventListener('mousemove', this.handleMouseMove)
  }

  handleMouseMove(e){
    const { marketMap } = this.props;
    let mouseX = e.clientX - marketMap.left;
    if((mouseX) > (marketMap.width / 2)){
      this.setState({positionX: mouseX - 500}) 
    } else {this.setState({positionX: mouseX + 100})}
  }



  render() {
    const { industrie, ticker } = this.props;
    //console.log('ticker', ticker)
    return (
      <div className='sc-market-map-popup'
        style={{left:this.state.positionX, width:'350px',color:'#000'}}>
        <div className='sc-market-map-popup-wrapper'>
          <div className={'sc-market-map-popup-title'} style={{borderBottom: !ticker ? '1px solid gray': ''}}>
            {industrie ? industrie.title : ''}
          </div>
          {
            ticker &&
            <div className='sc-market-map-popup-header' style={{backgroundColor: getColor(ticker.color)}}>
              <div>{ticker.title}</div>
              <div>{ticker.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
              <div>{isNaN(ticker.color) ? 'N/A' : ticker.color.toFixed(1) + '%' }</div>
            </div>
          }
          <div className='sc-market-map-popup-items-wrapper'>
            {
              industrie && industrie.tickers.map((_ticker, index)=>{
                if(_ticker.price && (!ticker || (ticker && ticker.id !==_ticker.id ))){
                  let classes = 'sc-market-map-popup-items'
                  if(index !== industrie.tickers.length - 1){classes += ' boder-bottom-sec'}
                  return (
                    <div className={classes} key={index + _ticker.title + _ticker.scale}>
                      <div>{_ticker.title}</div>
                      <div>{_ticker.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
                      <div style={{color: getColor(_ticker.color)}}>{isNaN(_ticker.color) ? 'N/A' : _ticker.color.toFixed(1) + '%' }</div>
                    </div>
                  )
                } else { return null }
              })
            }
          </div>
        </div>
      </div>
    );
  }
}




export default Popup;















// import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
// import Sector from './Sector';
// import { divide } from '../../../../../models/market-map/divider';
// import { Spinner } from "@blueprintjs/core";
// import Footer from './Footer';
// import Popup from './Popup';
// import './index.css';


// class Map extends Component {

//   constructor(props) {
//     super(props);
//     this.state = {
//       marketMap:null,
//       industrie:null,
//       sectors: []
//     }
//     //this.setMarketMapRatio = this.setMarketMapRatio.bind(this);
//     this.divideSectors = this.divideSectors.bind(this);
//     this.handleMouseHover = this.handleMouseHover.bind(this);
//   }

//   componentDidMount(){
//     // /this.setMarketMapRatio(true);
//     this.divideSectors(this.props.dataSource)
//     //window.addEventListener('resize', this.setMarketMapRatio)
//   }
  
//   componentWillReceiveProps(newProps){
//     if(newProps.dataSource.updatedAt !== this.props.dataSource.updatedAt){
//       const { dataSource } = newProps;
//       this.divideSectors(dataSource.data)
//     }
//   }
  
//   // componentWillUnmount(){
//   //   window.removeEventListener('resize', this.setMarketMapRatio)
//   // }

//   divideSectors(data){
//     var marketMap = ReactDOM.findDOMNode(this.refs.market_map).getBoundingClientRect();
//     let sectors = divide(data,marketMap.width+13,marketMap.height-8,0,0) //(data array, width, height, left, top);
//     this.setState({sectors, marketMap})
//   }
  
    
//   // setMarketMapRatio(firstTime){
//   //   var marketMap = ReactDOM.findDOMNode(this.refs.market_map).getBoundingClientRect();
//   //   if(marketMap.width > 700){
//   //     this.setState({marketMapWidth:marketMap.width,mapScrollX:'hidden'})
//   //   } else if(firstTime) {
//   //     this.setState({marketMapWidth:700,mapScrollX:'scroll'})
//   //   } else {
//   //     this.setState({mapScrollX:'scroll'})
//   //   }
//   // }

//   handleMouseHover(industrie){
//     this.setState({industrie})
//   }

  
//   render() {
//     const { sectors, marketMap, industrie } = this.state;
//     return (
//       <div className='sc-market-map-container' 
//         onMouseMove={this.handleMouseMove}>
//         <div className='sc-market-map-wrapper' ref="market_map">
//           {sectors.map((sector, index)=>{ return (<Sector key={index + sector.title + sector.scale} sector={sector} onMouseHover={this.handleMouseHover}/>)})}
//         </div>
//         <Footer />
//         {industrie ? <Popup industrie={industrie} marketMap={marketMap}/> : ''}
//         {sectors.length === 0  &&
//           <div className='sc-market-map-spinner'>
//             <Spinner className='sc-market-map-indicator' intent={"primary"} size={100} value={null} />
//           </div>
//         }
//       </div>
//     );
//   }
// }




// export default Map;




